var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWhitePooledUser = function SvgWhitePooledUser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.686 10.308A3.62 3.62 0 0 0 8.24 7.956H5.76a3.62 3.62 0 0 0-3.445 2.35l-.728 2.052h10.826zM7 7a2.68 2.68 0 1 0 0-5.36A2.68 2.68 0 0 0 7 7"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWhitePooledUser);
export default ForwardRef;